import { GenericTestRouteState } from './generic-test-state'

export const ClockTestRouteState = GenericTestRouteState.named(
  'ClockTestRouteState'
)
